
namespace Matrix.DataAudit {

	@Serenity.Decorators.registerClass()
	export class AccountHistoryGrid extends SiteEntityGrid<AccountHistoryRow, any> {
        protected getColumnsKey() { return 'DataAudit.AccountHistory'; }
        protected getDialogType() { return AccountHistoryDialog; }
        protected getIdProperty() { return AccountHistoryRow.idProperty; }
        protected getLocalTextPrefix() { return AccountHistoryRow.localTextPrefix; }
        protected getService() { return AccountHistoryService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}